import { render, staticRenderFns } from "./CreatePush.vue?vue&type=template&id=0d987409&"
import script from "./CreatePush.vue?vue&type=script&lang=js&"
export * from "./CreatePush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d987409')) {
      api.createRecord('0d987409', component.options)
    } else {
      api.reload('0d987409', component.options)
    }
    module.hot.accept("./CreatePush.vue?vue&type=template&id=0d987409&", function () {
      api.rerender('0d987409', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PushMessage/Modals/CreatePush.vue"
export default component.exports